import React, { useState } from "react";
import Delivery from "../../assets/images/delivery.png";
import HeroBg from "../../assets/images/heroBg.png";
import { heroData } from "../../data/dummyData";
import { motion } from "framer-motion";

const MainContainer = () => {
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });

  const handleHover = (e) => {
    const { clientX, clientY } = e;
    const buttonRect = e.currentTarget.getBoundingClientRect();
    const x = clientX - buttonRect.left - buttonRect.width / 2;
    const y = clientY - buttonRect.top - buttonRect.height / 2;
    setHoverPosition({ x, y });
  };

  const cartVariants = {
    initial: {
      rotateX: 0,
      rotateY: 0,
    },
    hover: {
      rotateX: -hoverPosition.y / 6, // Adjust the division factor as needed
      rotateY: hoverPosition.x / 6, // Adjust the division factor as needed
      transition: {
        duration: 0.05,
        yoyo: Infinity, // Make the animation repeat indefinitely
      },
    },
  };
  return (
    <section
      className="grid grid-cols-1 justify-center items-center md:grid-cols-2 gap-2"
      id="home"
    >
      <div className="py-2 flex-1 flex flex-col items-start justify-center  gap-6">
        <div className="flex items-center gap-2  bg-orange-100 px-2 py-1">
          <p className="text-base text-orange-500 font-semibold ">
            Bike Delivery
          </p>
          <div className="w-8 h-8 bg-white rounded-full overflow-hidden drop-shadow-xl">
            <img src={Delivery} alt="Delivery Bike" />
          </div>
        </div>
        <p className=" text-[2.5rem] lg:text-[4.5rem]  font-bold tracking-wide text-headingColor ">
          The Fastest Delivery in{" "}
          <span className=" text-orange-600 text-[3rem] lg:text-[5rem] ">
            Your City
          </span>
        </p>
        <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quisquam
          asperiores magni impedit, pariatur tenetur amet velit omnis dolorem in
          totam optio et earum minima suscipit voluptatibus ad dicta hic modi!
        </p>
        <button
          type="button"
          className=" bg-gradient-to-br from-orange-400 to-orange-500 
          w-full md:w-auto px-4 py-2 rounded-lg hover:shadow-xl transition-all duration-100 ease-in-out active:scale-95 "
        >
          Order Now
        </button>
      </div>
      <div className="py-2 relative flex-1 ">
        <img
          src={HeroBg}
          alt="HeroBg"
          className=" md:h-370 lg:h-600 mx-auto w-full h-[450px] md:w-auto  "
        />
        <div
          style={{ gridTemplateColumns: "auto auto" }}
          className="w-full absolute right-0 -ml-[67.5px] top-0  md:-right-0 lg:-right-0 xl:right-24  px-32 py-4 grid md:gap-y-16 md:gap-x-5 gap-x-5 gap-y-5   lg:gap-4 justify-center items-center"
        >
          {heroData.map((item, idx) => (
            <motion.div
              variants={cartVariants}
              initial="initial"
              whileHover="hover"
              whileTap={{ scale: 0.9 }}
              onMouseMove={handleHover}
              key={item.id}
              className=" cursor-pointer w-150 lg:w-190 lg:min-w-[190px] lg:mt-20 p-2 mt-10 md:mt-0 bg-cardOverlay  shadow-xl backdrop-blur-md rounded-3xl flex flex-col items-center"
            >
              <motion.img
                whileTap={{ scale: 3 }}
                
                id="rotate"
                src={item.imageSrc}
                className="w-20 h-20 -mt-10 md:w-24 md:h-24 md:-mt-14 lg:w-40 lg:h-40 lg:-mt-20"
                alt=""
              />
              <p className=" font-semibold text-md text-textColor lg:text-xl mt-4">
                {item.name}
              </p>
              <p className=" text-sm lg:text-base font-semibol text-lighttextGray my-3">
                {item.decp}
              </p>
              <p className="text-sm font-semibold text-headingColor">
                <span className="text-xs text-red-600">$</span>
                {item.price}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainContainer;
